/** Pricing proposal only; this does not authorize sales or change old contracts. */
export const FREE_PRICE_LABEL = "$0";
export const PRO_PRICE_AMOUNT = "$5.99";
export const PRO_PRICE_LABEL = `${PRO_PRICE_AMOUNT} / month (proposed)`;
export const PRO_PRICE_NOTICE =
  "Proposed USD price. Final price, taxes, billing currency and allowances will be confirmed before launch.";
export const PRO_WAITLIST_CTA = "Join the Pro waitlist";
export const GPU_PRICE_NOTICE =
  "Managed GPU access is planned for Pro. GPU usage is billed separately and is not included in the subscription.";
export const PRO_WAITLIST_NOTICE =
  "Pro is coming soon. Joining the waitlist is free and does not start a subscription or create a charge.";
